import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { HttpService } from '@/features/api/http.service';
import type { IPlaceVerification } from '@/types';

const PATH = '/places/verification';

export interface PlaceVerificationQuery {
  name: string;
  latitude: number;
  longitude: number;
}

export const placeVerificationKeyFactory = createQueryKeys('placeVerification', {
  verify: (place: PlaceVerificationQuery) => ({
    queryKey: [place.name, place.latitude, place.longitude],
    queryFn: () =>
      HttpService.get<undefined, IPlaceVerification>(PATH, {
        name: place.name,
        latitude: place.latitude,
        longitude: place.longitude,
      }),
  }),
});

/** Asks the place directory once per opening of the card. A failure leaves the card unstamped. */
export function usePlaceVerificationQuery(place: PlaceVerificationQuery) {
  return useQuery({
    ...placeVerificationKeyFactory.verify(place),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: 'always',
  });
}
